module.exports = __webpack_public_path__ + "img/vexere_web.b6f0f869.png";